<template>
    <div class="content">
        <div class="title" style="margin-bottom:28px;">IFM会员活动</div>
        <div v-for="(item, index) in list" :key="index" class="single">
            <div style="cursor:pointer" @click="$router.push('/activityDetail?id='+item.id)">
                <div class="title">{{item.title}}</div>
                <div class="subcontent">{{item.content}}</div>
                <div class="time">{{item.time}}</div>
            </div>
            
            <div :class="Number(item.is_over)===1?'has-end':''" class="btn" @click="goDetail(item)">{{Number(item.is_over)===1?'已结束':'报名参加'}}</div>
        </div>
        <el-pagination
            v-if="Number(total)!==0"
            style="padding-left:300px"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="limit"
            :total="Number(total)"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
    </div>
</template>
<script>
export default {
    data() {
        return {
            list:[
                
            ],
            page:1,
            limit: 20,
            total: 0
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        async getList(){
            const res = await this.$http.get('/api/index/getActivityList',{page:this.page,limit:this.limit});
            this.list = res.list;
            this.total = res.total;
        },
        handleSizeChange(size){
            this.limit = size;
            this.getList();
        },
        handleCurrentChange(page){
            this.page = page;
            this.getList();
        },
        goDetail(item){
            if(Number(item.is_over)!==1){
                this.$router.push('/joinActivity?id='+item.id);
            }
            console.log(item); 
        }
    },
}
</script>
<style lang="scss" scoped>
.content{
    width:1120px;
    margin:auto;
    box-sizing: border-box;
    padding: 30px;
    background: #f0f0f0;
    margin-bottom: 40px;
    .title{
        font-size: 22px;
        color: #235483;
        letter-spacing: 0.62px;
        font-weight: 600;
    }
}
.single{
    width:100%;
    box-sizing: border-box;
    padding: 17px;
    margin-bottom: 20px;
    background: #fff;
    position: relative;
    .title{
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0.45px;
        font-weight: 600;
        padding-right: 124px;
    }
    .subcontent{
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333333;
        padding-right: 124px;
        letter-spacing: 0.4px;
        font-weight: 400;
        margin: 12px 0 14px 0;
        display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 3;
overflow: hidden;
    }
    .time{
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #3B3B3B;
        letter-spacing: 0.4px;
        font-weight: 400;
    }
    .btn{
        width: 89px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #FFFFFF;
        letter-spacing: 0.45px;
        font-weight: 600;
        background: #A4204F;
        position: absolute;
        right:32px;
        top:59px;
        cursor: pointer;
    }
    .has-end{
        background: #EDEDED !important;
        color: #999999 !important;
        cursor: none;
    }
}
</style>
